export default __webpack_public_path__ + "static/media/powered-by-onezoey.629b594c.svg";